{
  "VALIDATION_FAILED": "راجع الحقول المحددة وصحح القيم المدخلة.",
  "UNAUTHENTICATED": "سجل الدخول للمتابعة.",
  "INVALID_CREDENTIALS": "اسم المستخدم أو كلمة المرور غير صحيح. حاول مجددا.",
  "ACCOUNT_LOCKED": "تم قفل الحساب مؤقتا بسبب محاولات كثيرة. حاول مجددا بعد 15 دقيقة.",
  "ACCOUNT_INACTIVE": "الحساب غير نشط، تواصل مع المسؤول",
  "ACCOUNT_PENDING": "لم يكتمل تسجيل هذا الحساب بعد. تواصل مع المسؤول للحصول على رابط إكمال تسجيل جديد.",
  "UNKNOWN_CARD": "البطاقة غير معروفة",
  "TOKEN_EXPIRED": "انتهت صلاحية الجلسة",
  "TOKEN_REVOKED": "تم إلغاء الجلسة",
  "FORBIDDEN": "لا تملك صلاحية لهذا الإجراء",
  "NOT_FOUND": "العنصر المطلوب غير موجود",
  "CONFLICT": "تعارض في البيانات",
  "UNIQUE_VIOLATION": "القيمة مستخدمة مسبقا",
  "FOREIGN_KEY_VIOLATION": "هذا السجل مرتبط بسجلات أخرى. راجع الروابط قبل تغييره.",
  "RATE_LIMITED": "عدد كبير من المحاولات، حاول لاحقا",
  "IDEMPOTENCY_KEY_REUSED": "سبق استخدام هذا الطلب ببيانات مختلفة. افتح نموذجا جديدا لإرسال البيانات المعدلة.",
  "REQUEST_IN_PROGRESS": "ما زال طلب سابق قيد التنفيذ. انتظر قليلا قبل إعادة المحاولة.",
  "PAYLOAD_TOO_LARGE": "حجم البيانات المرسلة أكبر من المسموح. قللها وحاول مجددا.",
  "UNPROCESSABLE": "تعذر إكمال الإجراء. راجع البيانات المدخلة وحاول مجددا.",
  "INTERNAL_ERROR": "تعذر إكمال الإجراء. حاول مجددا أو زود المدير برقم المرجع.",
  "SERVICE_UNAVAILABLE": "الخدمة غير متاحة مؤقتا. حاول مجددا بعد قليل.",
  "network": "تعذر الاتصال بالخادم. تحقق من الاتصال وحاول مجددا.",
  "timeout": "لم يتم تأكيد اكتمال العملية. تحقق من الحالة قبل إعادة المحاولة.",
  "referenceId": "رقم المرجع: {{requestId}}",
  "SSO_UNAVAILABLE": "خدمة تسجيل الدخول غير متاحة مؤقتا. حاول مجددا بعد قليل.",
  "SSO_SESSION_REVOKED": "انتهت جلستك. سجل الدخول مجددا.",
  "SSO_IDENTITY_INACTIVE": "هذا الحساب غير متاح. تواصل مع المدير.",
  "SSO_BRANCH_INACTIVE": "هذا الفرع غير متاح. اختر فرعا آخر مسموحا لك.",
  "SSO_APPLICATION_INACTIVE": "هذا النظام غير متاح. تواصل مع المدير.",
  "REAUTHENTICATION_REQUIRED": "سجل الدخول مجددا لتأكيد هويتك قبل المتابعة.",
  "RECOVERY_INVALID": "انتهت صلاحية هذا الرابط أو سبق استخدامه. اطلب رابطا جديدا.",
  "RECOVERY_UNAVAILABLE": "طريقة الاسترداد هذه غير متاحة. تواصل مع المدير المخول.",
  "PASSWORD_REJECTED": "اختر كلمة مرور أخرى تستوفي الشروط المطلوبة.",
  "LAST_ADMINISTRATOR": "يجب إبقاء مدير منصة نشط واحد على الأقل قبل هذا التغيير.",
  "PERMISSION_DEPENDENCY": "تعتمد إحدى الصلاحيات المحددة على صلاحية أخرى. راجع الصلاحيات اللازمة.",
  "NO_BRANCH_ACCESS": "لا تملك صلاحية على أي فرع. تواصل مع المسؤول.",
  "BRANCH_NOT_ALLOWED": "لا تملك صلاحية العمل في هذا الفرع. اختر فرعا آخر.",
  "NO_PLATFORM_ACCESS": "لا تملك صلاحية على هذا النظام في الفرع المحدد.",
  "LAUNCH_FAILED": "تعذر فتح النظام. سجل الدخول مرة أخرى.",
  "PLATFORM_NOT_ALLOWED": "لا تملك صلاحية على هذا النظام.",
  "PLATFORM_UNAUTHORIZED": "تعذر التحقق من النظام. تواصل مع المسؤول.",
  "INVALID_LAUNCH_CODE": "رابط الفتح غير صالح أو منتهي. افتح النظام مجددا من الشاشة الرئيسية.",
  "PASSWORD_TOKEN_INVALID": "رابط تعيين كلمة المرور غير صالح أو منتهي. اطلب رابطا جديدا.",
  "USERNAME_TAKEN": "اسم المستخدم مستخدم مسبقا.",
  "SESSION_EXPIRED": "انتهت جلستك. سجل الدخول مجددا.",
  "SESSION_REVOKED": "تم إنهاء جلستك. سجل الدخول مجددا."
}
